export default function PHP_filter_var_array() {
  return (
    <div>
      <h1>PHP_filter_var_array</h1>
    </div>
  );
}
